'use client';
import styles from '../style.module.scss';
import React, { useState } from 'react';
import { IProduct } from '@mybestbrands/types';
import { getPLPThumbnailPath } from '@/app/lib/converters/convertAdditionalImages';
import { trackSSTEvent } from '@/app/utils/tracking';
import { useTranslation } from 'next-i18next';
import { NAMESPACES } from '@/app/i18nConfig';
import { getProductColorValue } from '@/app/utils';
import Image from 'next/image';

interface Props {
  locale: string;
  item: IProduct;
  trackingData?: object | null;
}

export function ListItemProductImage(props: Props) {
  const { item, trackingData } = props;
  const [imgSrc, setImgSrc] = useState(
    getPLPThumbnailPath(item.mainImageUrl, props.locale, item.retailerId, item.productId, 'xxl')
  );

  const { t } = useTranslation(NAMESPACES.COMMON);

  const discountInPercent =
    item.originalPrice && item.price ? Math.round((1 - item.price / item.originalPrice) * 100) : 0;

  return (
    <div
      onClick={() => trackSSTEvent('product_card_image_click', trackingData || null)}
      className={'d-flex justify-content-center align-items-center mb-3 position-relative'}>
      {discountInPercent > 0 && <div className={styles.discountLabel}>-{discountInPercent}%</div>}
      {!item.clickOutAllowed && (
        <i
          className={'position-absolute'}
          style={{
            top: '35%',
            fontSize: '1rem',
          }}>
          {t('OUT_OF_STOCK')}
        </i>
      )}
      <Image
        style={{
          width: '100%',
        }}
        unoptimized={true}
        className={`${styles.itemImg} ${props.item.clickOutAllowed ? '' : styles.imgUnavailable}`}
        loading="lazy"
        width={200}
        height={250}
        alt={`${props.item.brandName} ${props.item.name} ${getProductColorValue(props.item.colors)}`}
        onError={() => {
          setImgSrc(`/intstatic/images/20x25_white.jpg`);
        }}
        src={imgSrc}
      />
    </div>
  );
}
